import type { AxiosError } from 'axios';

// we use the flag `isAxiosError` provided by Axios to test wether or not this error comes from axios
// please refer to https://github.com/axios/axios/blob/master/lib/core/enhanceError.js
export const isHttpClientError = (error: unknown): error is AxiosError =>
  error instanceof Error && 'isAxiosError' in error;
